export default "__VITE_ASSET__MJnxFZ$$__"